import { Component } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

/**
 * Edit 02 Icon - Alternative edit/pencil icon with document
 * Used for edit actions in tables and forms
 */
@Component({
  selector: 'lib-edit-02-icon',
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      viewBox="0 0 16 16"
      [style.color]="color()"
      [class]="iconClass()"
      fill="none">
      <path
        d="M9.99967 15.1673H5.99967C2.37967 15.1673 0.833008 13.6207 0.833008 10.0007V6.00065C0.833008 2.38065 2.37967 0.833984 5.99967 0.833984H7.33301C7.60634 0.833984 7.83301 1.06065 7.83301 1.33398C7.83301 1.60732 7.60634 1.83398 7.33301 1.83398H5.99967C2.92634 1.83398 1.83301 2.92732 1.83301 6.00065V10.0007C1.83301 13.074 2.92634 14.1673 5.99967 14.1673H9.99967C13.073 14.1673 14.1663 13.074 14.1663 10.0007V8.66732C14.1663 8.39398 14.393 8.16732 14.6663 8.16732C14.9397 8.16732 15.1663 8.39398 15.1663 8.66732V10.0007C15.1663 13.6207 13.6197 15.1673 9.99967 15.1673Z"
        fill="currentColor" />
      <path
        d="M5.66688 11.7924C5.26022 11.7924 4.88688 11.6457 4.61355 11.3791C4.28688 11.0524 4.14688 10.5791 4.22022 10.0791L4.50688 8.0724C4.56022 7.68573 4.81355 7.18573 5.08688 6.9124L10.3402 1.65906C11.6669 0.332396 13.0135 0.332396 14.3402 1.65906C15.0669 2.38573 15.3935 3.12573 15.3269 3.86573C15.2669 4.46573 14.9469 5.0524 14.3402 5.6524L9.08688 10.9057C8.81355 11.1791 8.31355 11.4324 7.92688 11.4857L5.92022 11.7724C5.83355 11.7924 5.74688 11.7924 5.66688 11.7924ZM11.0469 2.36573L5.79355 7.61906C5.66688 7.74573 5.52022 8.03906 5.49355 8.2124L5.20688 10.2191C5.18022 10.4124 5.22022 10.5724 5.32022 10.6724C5.42022 10.7724 5.58022 10.8124 5.77355 10.7857L7.78022 10.4991C7.95355 10.4724 8.25355 10.3257 8.37355 10.1991L13.6269 4.94573C14.0602 4.5124 14.2869 4.12573 14.3202 3.76573C14.3602 3.3324 14.1335 2.8724 13.6269 2.35906C12.5602 1.2924 11.8269 1.5924 11.0469 2.36573Z"
        fill="currentColor" />
      <path
        d="M13.233 6.55221C13.1864 6.55221 13.1397 6.54555 13.0997 6.53221C11.3464 6.03888 9.95305 4.64555 9.45971 2.89221C9.38638 2.62555 9.53971 2.35221 9.80638 2.27221C10.073 2.19888 10.3464 2.35221 10.4197 2.61888C10.8197 4.03888 11.9464 5.16555 13.3664 5.56555C13.633 5.63888 13.7864 5.91888 13.713 6.18554C13.653 6.41221 13.453 6.55221 13.233 6.55221Z"
        fill="currentColor" />
    </svg>
  `,
})
export class Edit02IconComponent extends BaseIconComponent {}
